import { queryOptions } from "@tanstack/react-query";
import { api, unwrap } from "@/shared/lib/apiClient";

// The backend never 404s here — it returns { valid: false } for bad tokens, so this always resolves.
export function inviteStatusQueryOptions(token: string) {
  return queryOptions({
    queryKey: ["invite-status", token],
    queryFn: async () =>
      unwrap(
        await api.GET("/api/invites/{token}/status", {
          params: { path: { token } },
        }),
      ),
  });
}
